export class VACDATA {

  ID: number;
  Start_Timestamp: Date;
  VQuad_Timestamp: Date;

  Call_Timestamp: Date;
  VQuad_Location: string;
  VQuad_PhoneID: string;

  Start_GPS_Position: string;
  Start_GPS_Lat: number;
  Start_GPS_Long: number;
  GPS_Position: string;
  GPS_Lat: number;
  GPS_Long: number;  

  TestStatus: string;
  Direction: string;

  //Service: string;
  //Group: string;
  Endpoint_URI: string;
  IP_Address: string;
  //VLAN_Encap: string;
  //Endpoint_UA: string;
  //Call_ID: string;
  Test_Plan_Name: string;


  Absolute_MOS_V	: number;
  Relative_MOS_V: number;
  //Image_Size: string;
  //Video_Packet_Loss_Rate: number;
  //Video_Discard_Rate: number;
  //Video_Bandwidth: number;
  Video_Frame_Rate: number;
  Impaired_I_Frames: number;
  Impaired_BP_Frames: number;
  //Loss_Rate_within_I_Frames: number;
  Loss_Rate_within_BP_Frames: number;
  //Error_extension_through_GoP: number;
  EPSNR: number;
  //G1070_Video_MOS: number;
  //I_Frames_Received: number;
  //BP_Frames_Received: number;

  Relative_MOS_A: number;
  ////Audio_Packet_Loss_Rate: number;
  ////Audio_Discard_Rate: number;
  //Audio_Bitrate: number;
  Audio_Bandwidth: number;
  Signal_Level: number;
  Noise_Level: number;
  //G1070_Audio_MOS: number;

  Relative_MOS_AV: number;
  ////Total_Round_Trip_Delay: number;
  //End_System_Delay: number;
  ////Network_Round_Trip_Delay_AV	: 	number	;
  ////IP_Network_Health: number;

  Network_Packet_Loss_Rate: number;
  Network_Packet_Discard_Rate: number;
  //Network_Packet_Duplicate_Rate: number;
  //Network_Packet_Reorder_Rate: number;
  Mean_Burst_Loss_Rate: number;
  Mean_Burst_Length: number;
  Mean_Gap_Loss_Rate: number;
  Mean_Gap_Length: number;
  Jitter__PPDV_: number;
  //MAPDV_Avg: number;
  //Network_Round_Trip_Delay: number;

  //Service_Access_Result: string;
  //Service_Access_Delay: number;
  //Service_Access_Fail_Count: number;
  //Session_Disconnect_Cause: string;
  //Session_Disconnect_Delay: number;
  //Session_Disconnect_Direction: string;

  //Video_Codec_Type: string;
  Image_Resolution: string;
  //GoP_Type: string;
  GoP_Length: number;
  Audio_Codec_Type: string;
  Audio_Sample_Rate: string;
  //Audio_Packet_Duration: number;
  //Transport_Protocol: string;
  //Signaling_Type: string;
  Video_Codec_PLC_Type: string;
  Audio_Codec_PLC_Type: string;

  CallType_Orig: string;
  CallType_Term: string;
  VQuad_CallID: string;

  constructor() {
    this.ID = 0;

    this.Start_Timestamp = new Date();
    this.VQuad_Timestamp = new Date();

    this.Call_Timestamp = new Date();
    this.VQuad_Location = "";
    this.VQuad_PhoneID = "";


    this.Start_GPS_Position = "";
    this.Start_GPS_Lat = 0;
    this.Start_GPS_Long = 0;
    this.GPS_Position = "";
    this.GPS_Lat = 0;
    this.GPS_Long = 0;

    this.TestStatus = "";
    this.Direction = "";

    //this.Service = "";
    //this.Group = "";
    this.Endpoint_URI = "";
    this.IP_Address = "";
    //this.VLAN_Encap = "";
    //this.Endpoint_UA = "";
    //this.Call_ID = "";
    this.Test_Plan_Name = "";

    this.Absolute_MOS_V	= 0	;
    this.Relative_MOS_V	= 0;
    //this.Image_Size = "";
    //this.Video_Packet_Loss_Rate = 0;
    //this.Video_Discard_Rate = 0;
    //this.Video_Bandwidth = 0;
    this.Video_Frame_Rate = 0;
    this.Impaired_I_Frames = 0;
    this.Impaired_BP_Frames = 0;
    //this.Loss_Rate_within_I_Frames = 0;
    this.Loss_Rate_within_BP_Frames = 0;
    //this.Error_extension_through_GoP = 0;
    this.EPSNR = 0;
    //this.G1070_Video_MOS = 0;
    //this.I_Frames_Received = 0;
    //this.BP_Frames_Received = 0;

    this.Relative_MOS_A	= 0	;
    ////this.Audio_Packet_Loss_Rate = 0;
    ////this.Audio_Discard_Rate = 0;
    //this.Audio_Bitrate = 0;
    this.Audio_Bandwidth = 0;
    this.Signal_Level = 0;
    this.Noise_Level = 0;

    //this.G1070_Audio_MOS = 0;
    this.Relative_MOS_AV	= 0	;
    ////this.Total_Round_Trip_Delay = 0;
    //this.End_System_Delay = 0;
    ////this.Network_Round_Trip_Delay_AV	=0;
    ////this.IP_Network_Health = 0;

    this.Network_Packet_Loss_Rate = 0;
    this.Network_Packet_Discard_Rate = 0;
    //this.Network_Packet_Duplicate_Rate = 0;
    //this.Network_Packet_Reorder_Rate = 0;
    this.Mean_Burst_Loss_Rate = 0;
    this.Mean_Burst_Length = 0;
    this.Mean_Gap_Loss_Rate = 0;
    this.Mean_Gap_Length = 0;
    this.Jitter__PPDV_	= 0;
    //this.MAPDV_Avg = 0;
    //this.Network_Round_Trip_Delay = 0;

    //this.Service_Access_Result = "";
    //this.Service_Access_Delay = 0;
    //this.Service_Access_Fail_Count = 0;
    //this.Session_Disconnect_Cause = "";
    //this.Session_Disconnect_Delay = 0;
    //this.Session_Disconnect_Direction = "";

    //this.Video_Codec_Type = "";
    this.Image_Resolution = "";
    //this.GoP_Type = "";

    this.GoP_Length = 0;
    this.Audio_Codec_Type = "";
    this.Audio_Sample_Rate = "";

    //this.Audio_Packet_Duration = 0;
    //this.Transport_Protocol = "";
    //this.Signaling_Type = "";
    this.Video_Codec_PLC_Type = "";
    this.Audio_Codec_PLC_Type = "";

    this.CallType_Orig = "";
    this.CallType_Term = "";
    this.VQuad_CallID = "";    
  }
}
